import Text from 'common-components/Text'
import styled from 'styled-components'

export const SoundInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const SoundsDuration = styled(Text)`
  line-height: 12px;
`

export const SoundsTitle = styled(Text)`
  line-height: 12px;
  width: 114px;
`
